import { Box, Button, Typography } from '@mui/material'
import { colorPrimitives } from 'components/Theme'
import ExportIcon from 'assets/export.svg'
import { useState } from 'react'
import { EmployeesExcludeImport } from './EmployeesExcludeImport'

export const EmployeesExclude = () => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false)

  const toggleImportModalIsOpen = async () => {
    setIsImportModalOpen(!isImportModalOpen)
  }
  return (
    <>
      <Typography variant="h6">Exclude Employees</Typography>
      <Box
        className={`p-6 border-[1px] border-[${colorPrimitives.borderGray}] rounded-lg flex flex-col lg:flex-row mt-2`}
      >
        <Box className="flex flex-row gap-6 w-3/4 items-center">
          <Typography variant="body-1">
            Mark employees as excluded by phone number
          </Typography>
        </Box>

        <Box className="lg:w-1/4 flex lg:justify-end mt-6 lg:mt-0">
          <Button variant="contained" onClick={toggleImportModalIsOpen}>
            <img src={ExportIcon} width={15} height={15} alt="Export icon" />
            <Typography variant="label-CTA">Import</Typography>
          </Button>
        </Box>
      </Box>
      <EmployeesExcludeImport
        isModalOpen={isImportModalOpen}
        toggleModalIsOpen={toggleImportModalIsOpen}
      />
    </>
  )
}
